<template>
<svg :width="width" :height="height" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="35.5" cy="35" r="34.5" fill="var(--primary-orange)" stroke="var(--primary-orange)" />
<path d="M47.1465 23.3535L23.8535 46.6464M47.1465 46.6464L23.8535 23.3535" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
</svg>


</template>

<script>
export default {
    name: 'ConfirmationErrorSvg',
    props: {
        width: {
            type: Number,
            default: 100,
        },
        height: {
            type: Number,
            default: 100,
        },
    },
}
</script>

